export function dataInRequest(params = {}) {
  return {
    type: '@abastecimentoA2VF/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@abastecimentoA2VF/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@abastecimentoA2VF/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@abastecimentoA2VF/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@abastecimentoA2VF/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@abastecimentoA2VF/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@abastecimentoA2VF/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@abastecimentoA2VF/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@abastecimentoA2VF/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@abastecimentoA2VF/RECORD_FILTERING',
    payload: { params },
  };
}
